export const useUnregisterFirebase = (_should: boolean) => {};
